export const GET_DIMENSION_SUCCESS = "GET_DIMENSION_SUCCESS";
